// 用戶反饋表單組件
export default {
  // 頁面標題
  title: "用戶反饋列表",
  subtitle: "使用過程中遇到的問題？",

  // 表單標籤
  problemType: "問題類型",
  problemDescription: "問題描述",
  phoneNumber: "手機號",
  email: "郵箱",

  // 問題類型選項
  problemFeedback: "問題反饋",
  featureSuggestion: "功能建議",
  caseAssistance: "案情協助",

  // 佔位符
  phonePlaceholder: "請輸入手機號",
  emailPlaceholder: "請輸入郵箱",

  // 按鈕
  reset: "重置",
  submit: "提交",
  close: "關閉",
  confirm: "確認",

  // 成功提示
  submitSuccess: "提交成功，感謝您的建議",

  // 表單驗證
  phoneRequired: "請輸入手機號",
  phoneLengthRule: "長度在 7 到 12 個字符",
  emailRequired: "請輸入郵箱",
  typeRequired: "請選擇問題類型",
  contentRequired: "請填寫問題描述",
};
